export const REQUESTOR_TO_FILL_LA_T1_FORM_KEY = 'requestorToFillLAT1Form'
export const REQUESTOR_FILL_EMEA_FORM_KEY = 'requestorFillEMEAForm'
export const REQUESTOR_FILL_APJ_FORM_KEY = 'requestorFillAPJForm'
export const REQUESTOR_FILL_APJ_T1_FORM_KEY = 'requestorFillAPJT1Form'
export const LNR_CHAMPION_FORM_KEY = 'legalAndRegulatoryChampionForm'
export const PARTNER_EXCLUSION_FORM_KEY = 'partnerExclusionForm'

export const REQUESTOR_FILL_BUSINESS_UNITS = ['PPS']
